import { render, staticRenderFns } from "./BalanceAddressPaperWallet.vue?vue&type=template&id=119a126c&scoped=true&"
import script from "./BalanceAddressPaperWallet.vue?vue&type=script&lang=js&"
export * from "./BalanceAddressPaperWallet.vue?vue&type=script&lang=js&"
import style0 from "./BalanceAddressPaperWallet.vue?vue&type=style&index=0&id=119a126c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a126c",
  null
  
)

export default component.exports